export enum ModalId {
  Geolocation,
  PackageDetails,
  PriceBreakdown
}

export const ModalPriorities = {};
